<div class="color-system">
  @if (openPart !== null) {
    <div class="close-dropdown-overlay" (click)="closeColorPalette()"></div>
  }

  <app-tooth-part
    [generalBase]="getColorByAttributeName(formGroup.get(ColorAttributes.base)?.value)"
    [topBase]="getColorByAttributeName(formGroup.get(ColorAttributes.top)?.value)"
    [middleBase]="getColorByAttributeName(formGroup.get(ColorAttributes.middle)?.value)"
    [bottomBase]="getColorByAttributeName(formGroup.get(ColorAttributes.bottom)?.value)"
    [partCount]="colorAttributeNames.length">
  </app-tooth-part>

  <div>
    <label>{{ 'dental.product_configuration.select_color.label' | translate }}*</label>

    @for (controlName of colorAttributeNames; track controlName) {
      <div class="cs-dropdown">
        <div
          [ngClass]="{
            'top-arrow': openPart === controlName,
            invalid: formGroup.get(controlName).invalid && formGroup.get(controlName)?.touched,
          }"
          class="cs-dropdown__select"
          (click)="openColorPalette(controlName)">
          @if (getColorByAttributeName(formGroup.get(controlName).value); as color) {
            <div
              [ngStyle]="{
                'background-color': color?.color,
                'width.px': 19,
                'height.px': 19,
              }"
              class="tooth-color"></div>
            <span class="ms-2">{{ color?.label }}</span>
          }
        </div>
        @if (openPart === controlName) {
          <div class="cs-dropdown__colors pb-0">
            @for (items of colors | keyvalue; track items) {
              <div class="cs-dropdown__colors__grid">
                @for (color of items.value; track color) {
                  <div class="cs-dropdown__colors__grid__item" (click)="handleColorPaletteClick(color.id, controlName)">
                    <div
                      [ngStyle]="{ 'background-color': color?.color }"
                      [class.selected-color]="color?.id === formGroup.get(controlName).value"
                      class="tooth-color"></div>
                    <p>{{ color?.label }}</p>
                  </div>
                }
              </div>
            }
          </div>
        }
        @if (colorAttributeNames.length > 1) {
          <i class="fas fa-trash ms-2" (click)="handleRemoveColor(controlName)"></i>
        }
      </div>
    }

    @if (colorAttributeNames.length < 3) {
      <p class="toggle-extra-colors" (click)="handleAddColor()">
        <span>
          <i class="fas fa-plus me-2"></i>
          {{ 'dental.product_configuration.add_extra_colors.label' | translate }}
        </span>
      </p>
    }
  </div>
</div>
